import axios from 'axios'

import env from '../environments'

export async function track(eventName: string, data?: Record<string, any> | undefined) {
	return axios.post(env.apiUrl + '/obiwan/kenobi', {
		eventName,
		data
	})
}
